<template>
  <div class="main_header" v-loading.fullscreen.lock="loading">
    <div class="layout_header_content">
      <h1 class="main_header_log">
        <img src="@/assets/image/logo_header.png" />
        <span>“传统医学师承和确有专长”及“中医医术确有专长”考核报名系统</span>
        <div class="editionType" v-if="editionType">{{testTxt}}</div>
      </h1>
      <div class="user_tag">
        <span class="userName">Hi , {{userName}}</span>
        <a @click="updataCipher">修改密码</a>
        <span class="line"></span>
        <a @click="logOut">退出</a>
      </div>
    </div>
    <!--修改密码-->
    <Modal v-model="updataPassState" width="600" title="修改密码" :mask-closable="false">
      <Form ref="updataPassform" :model="updataPassFrom" :rules="ruleCustom" :label-width="80">
        <FormItem label="原密码" prop="Oldpass">
          <Input type="password" password v-model="updataPassFrom.Oldpass" placeholder="请输入原密码" />
        </FormItem>
        <FormItem label="新密码" prop="Newpass">
          <Input type="password" password v-model="updataPassFrom.Newpass" placeholder="请输入新密码" />
        </FormItem>
        <FormItem label="确认密码" prop="passwdCheck">
          <Input
            type="password"
            password
            v-model="updataPassFrom.passwdCheck"
            placeholder="请再次输入密码"
          />
        </FormItem>
      </Form>
      <p class="updataPass_hint" style="color:#ff0000">*密码修改成功后将退出系统重新登录</p>
      <div slot="footer" style="text-align:center">
        <Button type="primary" icon="md-checkmark" @click="submit('updataPassform')">提交</Button>
        <Button type="primary" icon="md-close" @click="updataPassState=false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<style lang="less">
.main_header {
  width: 100%;
  background: #fff;
  height: 60px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 11;
  .layout_header_content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    .main_header_log {
      float: left;
      height: 100%;
      height: 60px;

      img {
        position: relative;
        top: 10px;
      }
      span {
        display: inline-block;
        font-weight: bold;
        font-size: 13px;
        color: #9c9c9c;
        padding-left: 15px;
        border-left: 1.5px solid #9c9c9c;
        margin-left: 15px;
        position: relative;
        top: -3px;
      }
      .editionType {
        position: absolute;
        left: 650px;
        top: 13px;
        height: 35px;
        line-height: 35px;
        color: #fff;
        background: #ff0000;
        padding: 0 20px;
        font-size: 18px;
      }
    }

    .user_tag {
      float: right;
      height: 60px;
      line-height: 60px;
      .userName {
        color: #777777;
        font-size: 14px;
        margin-right: 15px;
      }
      .line {
        display: inline-block;
        width: 1px;
        height: 12px;
        background: #bbbbbb;
        margin: 0 10px;
      }
      a {
        color: #00b49b;
        font-size: 14px;
      }
    }
  }
}
.updataPass_hint {
  padding-left: 80px;
  box-sizing: border-box;
}
</style>
<script>
import util from "@/libs/util";
import { AccountUpdataCipher } from "@/api/account/index";
export default {
  data() {
    const validateOldpasswd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入原密码"));
      } else {
        if (this.updataPassFrom.Newpass !== "") {
          // 对第二个密码框单独验证
          this.$refs.updataPassform.validateField("Newpass");
        }
        callback();
      }
    };
    const validatepasswd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.updataPassFrom.Oldpass == this.updataPassFrom.Newpass) {
          callback(new Error("旧密码与新密码相同"));
        } else {
          if (this.updataPassFrom.passwdCheck !== "") {
            // 对第二个密码框单独验证
            this.$refs.updataPassform.validateField("passwdCheck");
          }
          callback();
        }
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请重新输入密码"));
      } else if (value !== this.updataPassFrom.Newpass) {
        callback(new Error("两个输入密码不匹配!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      userNew: null,
      userName: "",
      updataPassState: false,
      updataPassFrom: {
        Oldpass: "",
        Newpass: "",
        passwdCheck: ""
      },
      ruleCustom: {
        Oldpass: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          {
            validator: validateOldpasswd,
            trigger: "blur"
          }
        ],
        Newpass: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            validator: validatepasswd,
            trigger: "blur"
          }
        ],
        passwdCheck: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          {
            validator: validatePassCheck,
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    let userNews = util.storage.getUserInfo();
    this.userNew = userNews;
    this.userName = userNews.real_name;
  },
  methods: {
    //修改密码
    updataCipher() {
      this.updataPassState = true;
    },
    //退出系统
    logOut() {
      this.$Modal.confirm({
        title: "提示",
        content: "确认退出系统?",
        onOk: () => {
          util.cookies.remove("token");
          util.storage.remove();
          this.$router.replace(this.$route.query.redirect || "/login");
        }
      });
    },
    //提交
    submit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.loading = true;
          let params = {
            old_pwd: this.$md5(this.updataPassFrom.Oldpass),
            new_pwd: this.$md5(this.updataPassFrom.Newpass),
            new_pwd2: this.$md5(this.updataPassFrom.passwdCheck)
          };
          AccountUpdataCipher(params)
            .then(() => {
              this.$Message.success("密码修改成功");
              this.loading = false;
              this.updataPassState = true;
              util.cookies.remove("token");
              util.storage.remove();
              this.$router.replace(this.$route.query.redirect || "/login");
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>